import Images from './images';
import IndianStates from './indian_states';
import Svgs from './svgs';
import ContestListFilter from './contest_filter';
import StaticURL from './static_url';
import GadgetLeague from './gadget_league';
import GameList from './game_list';
import Limit from './limit';
import Colors from './colors';
import InitialStatuses from './initial_statuses';
import Keys from './keys';
import GrandLeagueLeaderBoardList from './grand_league_leaderboard';
import SmallLeagueLeaderBoardList from './small_league_leaderboard';
import WeekendLeaderBoardList from './weekend_leaderboard';
import WeeklyLeaderBoardList from './weekly_leaderboard';
import YesNoRule from './yes_no_rule';
import GameType from './gameType';
import ContestCategories from './contest_categories';
import ContestTypes from './contest_types';
import FLAGS from './flags';
import MiniGames from './minigames';
import GuideTour from './guide_tour';
import SideBar from './sidebar';

export default {
  ContestListFilter,
  GadgetLeague,
  GameList,
  Limit,
  Images,
  IndianStates,
  Svgs,
  StaticURL,
  Colors,
  InitialStatuses,
  Keys,
  GrandLeagueLeaderBoardList,
  SmallLeagueLeaderBoardList,
  WeekendLeaderBoardList,
  WeeklyLeaderBoardList,
  YesNoRule,
  GameType,
  ContestCategories,
  ContestTypes,
  FLAGS,
  MiniGames,
  GuideTour,
  SideBar
};
